//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/compat/predicate/isArray.mjs
/**
* Checks if the given value is an array.
*
* This function tests whether the provided value is an array or not.
* It returns `true` if the value is an array, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to an array.
*
* @param value - The value to test if it is an array.
* @returns `true` if the value is an array, `false` otherwise.
*
* @example
* const value1 = [1, 2, 3];
* const value2 = 'abc';
* const value3 = () => {};
*
* console.log(isArray(value1)); // true
* console.log(isArray(value2)); // false
* console.log(isArray(value3)); // false
*/
function isArray(value) {
	return Array.isArray(value);
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/compat/predicate/isSymbol.mjs
/**
* Check whether a value is a symbol.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to `symbol`.
*
* @param value The value to check.
* @returns Returns `true` if `value` is a symbol, else `false`.
* @example
* isSymbol(Symbol.iterator);
* // => true
*
* isSymbol('abc');
* // => false
*/
function isSymbol$1(value) {
	return typeof value === "symbol" || value instanceof Symbol;
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/compat/util/toString.mjs
/**
* Converts `value` to a string.
*
* An empty string is returned for `null` and `undefined` values.
* The sign of `-0` is preserved.
*
* @param value - The value to convert.
* @returns Returns the converted string.
*
* @example
* toString(null) // returns ''
* toString(undefined) // returns ''
* toString(-0) // returns '-0'
* toString([1, 2, -0]) // returns '1,2,-0'
* toString([Symbol('a'), Symbol('b')]) // returns 'Symbol(a),Symbol(b)'
*/
function toString(value) {
	if (value == null) return "";
	return baseToString(value);
}
function baseToString(value) {
	if (typeof value === "string") return value;
	if (Array.isArray(value)) return value.map(baseToString).join(",");
	if (isSymbol$1(value)) return value.toString();
	const result = value + "";
	if (result === "0" && Object.is(Number(value), -0)) return "-0";
	return result;
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/compat/predicate/isObject.mjs
/**
* Checks if the given value is an object. An object is a value that is
* not a primitive type (string, number, boolean, symbol, null, or undefined).
*
* This function tests whether the provided value is an object or not.
* It returns `true` if the value is an object, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to an object value.
*
* @param value - The value to check if it is an object.
* @returns `true` if the value is an object, `false` otherwise.
*
* @example
* const value1 = {};
* const value2 = [1, 2, 3];
* const value3 = () => {};
* const value4 = null;
*
* console.log(isObject(value1)); // true
* console.log(isObject(value2)); // true
* console.log(isObject(value3)); // true
* console.log(isObject(value4)); // false
*/
function isObject(value) {
	return value !== null && (typeof value === "object" || typeof value === "function");
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/compat/util/toNumber.mjs
/**
* Converts `value` to a number.
*
* Unlike `Number()`, this function returns `NaN` for symbols.
*
* @param value - The value to convert.
* @returns Returns the number.
*
* @example
* toNumber(3.2); // => 3.2
* toNumber(Number.MIN_VALUE); // => 5e-324
* toNumber(Infinity); // => Infinity
* toNumber('3.2'); // => 3.2
* toNumber(Symbol.iterator); // => NaN
* toNumber(NaN); // => NaN
*/
function toNumber(value) {
	if (isSymbol$1(value)) return NaN;
	return Number(value);
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/predicate/isFunction.mjs
/**
* Checks if `value` is a function.
*
* @param value The value to check.
* @returns Returns `true` if `value` is a function, else `false`.
*
* @example
* isFunction(Array.prototype.slice); // true
* isFunction(async function () {}); // true
* isFunction(function* () {}); // true
* isFunction(Proxy); // true
* isFunction(Int8Array); // true
*/
function isFunction(value) {
	return typeof value === "function";
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/predicate/isDate.mjs
/**
* Checks if `value` is a Date object.
*
* @param value The value to check.
* @returns Returns `true` if `value` is a Date object, `false` otherwise.
*
* @example
* const value1 = new Date();
* const value2 = '2024-01-01';
*
* console.log(isDate(value1)); // true
* console.log(isDate(value2)); // false
*/
function isDate(value) {
	return value instanceof Date;
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/predicate/isString.mjs
/**
* Checks if a given value is string.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to `string`.
*
* @param value The value to check if it is string.
* @returns Returns `true` if `value` is a string, else `false`.
*
* @example
* const value1 = 'abc';
* const value2 = 123;
* const value3 = true;
*
* console.log(isString(value1)); // true
* console.log(isString(value2)); // false
* console.log(isString(value3)); // false
*/
function isString(value) {
	return typeof value === "string";
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/predicate/isSymbol.mjs
/**
* Check whether a value is a symbol.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to `symbol`.
*
* @param value The value to check.
* @returns Returns `true` if `value` is a symbol, else `false`.
*
* @example
* import { isSymbol } from 'es-toolkit/predicate';
*
* isSymbol(Symbol('a')); // true
* isSymbol(Symbol.for('a')); // true
* isSymbol(Symbol.iterator); // true
*
* isSymbol(null); // false
* isSymbol(undefined); // false
* isSymbol('123'); // false
* isSymbol(false); // false
* isSymbol(123n); // false
* isSymbol({}); // false
* isSymbol([1, 2, 3]); // false
*/
function isSymbol(value) {
	return typeof value === "symbol";
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/string/capitalize.mjs
/**
* Converts the first character of string to upper case and the remaining to lower case.
*
* @template T - Literal type of the string.
* @param str - The string to be converted to uppercase.
* @returns The capitalized string.
*
* @example
* const result = capitalize('fred') // returns 'Fred'
* const result2 = capitalize('FRED') // returns 'Fred'
*/
function capitalize(str) {
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/string/words.mjs
/**
* Regular expression pattern to split strings into words for various case conversions
*
* This pattern matches sequences of characters in a string, considering the following cases:
* - Sequences of two or more uppercase letters followed by an uppercase letter and lowercase letters or digits (for acronyms)
* - Sequences of one uppercase letter optionally followed by lowercase letters and digits
* - Single uppercase letters
* - Sequences of digits
* - Emojis and other Unicode characters
*
* The resulting match can be used to convert camelCase, snake_case, kebab-case, and other mixed formats into
* a consistent format like snake case. It also supports emojis and other Unicode characters.
*
* @example
* const matches = 'camelCaseHTTPRequest🚀'.match(CASE_SPLIT_PATTERN);
* // matches: ['camel', 'Case', 'HTTP', 'Request', '🚀']
*/
const CASE_SPLIT_PATTERN = /\p{Lu}?\p{Ll}+|[0-9]+|\p{Lu}+(?!\p{Ll})|\p{Emoji_Presentation}|\p{Extended_Pictographic}|\p{L}+/gu;
/**
* Splits `string` into an array of its words, treating spaces and punctuation marks as separators.
*
* @param str The string to inspect.
* @param [pattern] The pattern to match words.
* @returns Returns the words of `string`.
*
* @example
* words('fred, barney, & pebbles');
* // => ['fred', 'barney', 'pebbles']
*
* words('camelCaseHTTPRequest🚀');
* // => ['camel', 'Case', 'HTTP', 'Request', '🚀']
*
* words('Lunedì 18 Set')
* // => ['Lunedì', '18', 'Set']
*/
function words(str) {
	return Array.from(str.match(CASE_SPLIT_PATTERN) ?? []);
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/string/camelCase.mjs
/**
* Converts a string to camel case.
*
* Camel case is the naming convention in which the first word is written in lowercase and
* each subsequent word begins with a capital letter, concatenated without any separator characters.
*
* @param str - The string that is to be changed to camel case.
* @returns The converted string to camel case.
*
* @example
* const convertedStr1 = camelCase('camelCase') // returns 'camelCase'
* const convertedStr2 = camelCase('some whitespace') // returns 'someWhitespace'
* const convertedStr3 = camelCase('hyphen-text') // returns 'hyphenText'
* const convertedStr4 = camelCase('HTTPRequest') // returns 'httpRequest'
* const convertedStr5 = camelCase('Keep unicode 😅') // returns 'keepUnicode😅'
*/
function camelCase(str) {
	const words$1 = words(str);
	if (words$1.length === 0) return "";
	const [first, ...rest] = words$1;
	return `${first.toLowerCase()}${rest.map((word) => capitalize(word)).join("")}`;
}
//#endregion
//#region ../../node_modules/.bun/es-toolkit@1.52.0/node_modules/es-toolkit/dist/string/kebabCase.mjs
/**
* Converts a string to kebab case.
*
* Kebab case is the naming convention in which each word is written in lowercase and separated by a dash (-) character.
*
* @param str - The string that is to be changed to kebab case.
* @returns The converted string to kebab case.
*
* @example
* const convertedStr1 = kebabCase('camelCase') // returns 'camel-case'
* const convertedStr2 = kebabCase('some whitespace') // returns 'some-whitespace'
* const convertedStr3 = kebabCase('hyphen-text') // returns 'hyphen-text'
* const convertedStr4 = kebabCase('HTTPRequest') // returns 'http-request'
*/
function kebabCase(str) {
	return words(str).map((word) => word.toLowerCase()).join("-");
}
//#endregion
//#region src/index.ts
/**
* Logs an error message to the console prefixed with the [Lune] tag.
* @param msg - The error message string.
* @param args - Additional arguments or data to log alongside the error.
*/
function error(msg, ...args) {
	console.error(`[Lune] ERROR - ${msg}`, ...args);
}
/**
* Compares two values to see if they have changed, correctly handling NaN comparisons.
* @param value - The current value.
* @param oldValue - The previous value to compare against.
* @returns True if the values are different, false otherwise.
*/
function hasChanged(value, oldValue) {
	return !Object.is(value, oldValue);
}
/**
* Checks if an object has a specific property as its own (not inherited).
* @param val - The target object.
* @param key - The property key or symbol to check.
* @returns True if the property exists directly on the object.
*/
function hasOwn(val, key) {
	return Object.prototype.hasOwnProperty.call(val, key);
}
/**
* Logs a warning message to the console prefixed with the [Lune] tag.
* @param msg - The warning message string.
* @param args - Additional arguments or data to log alongside the warning.
*/
function warn(msg, ...args) {
	console.warn(`[Lune] WARN - ${msg}`, ...args);
}
//#endregion
export { camelCase, error, hasChanged, hasOwn, isArray, isDate, isFunction, isObject, isString, isSymbol, kebabCase, toNumber, toString, warn };
